import React from "react";
import { Routes, Route } from "react-router-dom";

import ProtectedRoute from "./routes/ProtectedRoute";

import LoginPage from "../pages/login/LoginPage";
import HomePage from "../pages/home/HomePage";
import ClientsPage from "../pages/clients/ClientsPage";
import ClientPage from "../pages/clients/ClientPage";
import ManagersPage from "../pages/managers/ManagersPage";

import MenuListPage from "../pages/menu/MenuListPage";
import MenuEditPage from "../pages/menu/MenuEditPage";
import MenuAddPage from "../pages/menu/MenuAddPage";

import SearchTagEditPage from "../pages/menu/tag/SearchTagEditPage";
import SearchTagAddPage from "../pages/menu/tag/SearchTagAddPage";


import OrgsPage from "../pages/orgs/OrgsPage";
import ProductsPage from "../pages/products/ProductsPage";
import ProductsCategoryAddPage from "../pages/products/ProductsCategoryAddPage";
import ProductsCategorys from "../pages/products/ProductsCategorys";

import MaterialsPage from "../pages/materials/MaterialsPage";
import MaterialAddPage from "../pages/materials/MaterialAddPage";

import ProductsAddPage from "../pages/products/ProductsAddPage";
import ArchivePage from "../pages/archive/ArchivePage";
import SettingPage from "../pages/setting/SettingPage";
import StatisticPage from "../pages/statistic/StatisticPage";

function AppNavigator() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/clients"
        element={
          <ProtectedRoute>
            <ClientsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/client"
        element={
          <ProtectedRoute>
            <ClientPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/managers"
        element={
          <ProtectedRoute>
            <ManagersPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/orgs"
        element={
          <ProtectedRoute>
            <OrgsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/products/category/:id"
        element={
          <ProtectedRoute>
            <ProductsPage />
          </ProtectedRoute>
        }
      />


      <Route
        path="/category/all"
        element={
          <ProtectedRoute>
            <ProductsCategorys />
          </ProtectedRoute>
        }
      />

      <Route
        path="/add/category"
        element={
          <ProtectedRoute>
            <ProductsCategoryAddPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/products/add"
        element={
          <ProtectedRoute>
            <ProductsAddPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/material/list"
        element={
          <ProtectedRoute>
            <MaterialsPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/material/add"
        element={
          <ProtectedRoute>
            <MaterialAddPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/material/all"
        element={
          <ProtectedRoute>
            <MaterialsPage />
          </ProtectedRoute>
        }
      />



      <Route
        path="/menu"
        element={
          <ProtectedRoute>
      
              <MenuListPage />
            
          </ProtectedRoute>
        }
      />

      <Route
        path="/edit/menu/:id"
        element={
          <ProtectedRoute>
      
              <MenuEditPage />
            
          </ProtectedRoute>
        }
      />

      <Route
        path="/edit/menu/tag/:id"
        element={
          <ProtectedRoute>
      
              <SearchTagEditPage />
            
          </ProtectedRoute>
        }
      />

      <Route
        path="/menu/tag/add/:id"
        element={
          <ProtectedRoute>
      
              <SearchTagAddPage />
            
          </ProtectedRoute>
        }
      />



      <Route
        path="/menu/add"
        element={
          <ProtectedRoute>
      
              <MenuAddPage />
            
          </ProtectedRoute>
        }
      />





      <Route
        path="/archive"
        element={
          <ProtectedRoute>
            <ArchivePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/setting"
        element={
          <ProtectedRoute>
            <SettingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/statistic"
        element={
          <ProtectedRoute>
            <StatisticPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default AppNavigator;
